import React, { useRef, useCallback, useState } from 'react';
import Webcam from 'react-webcam';

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user"
};

const CameraCapture = ({ onCapture }) => {
  const webcamRef = useRef(null);
  const [error, setError] = useState(null);

  const capture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        onCapture(imageSrc);
      }
    }
  }, [webcamRef, onCapture]);

  if (error) {
    return (
      <div className="error-message" style={{ color: 'red', padding: '20px' }}>
        <p>Camera Error: {error.message || "Could not access camera"}</p>
        <p>Please ensure camera permissions are granted.</p>
      </div>
    );
  }

  return (
    <div className="camera-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        width={400}
        videoConstraints={videoConstraints}
        onUserMediaError={setError}
      />
      <button onClick={capture} style={{ padding: '10px 20px', fontSize: '16px' }}>Capture Photo</button>
    </div>
  );
};

export default CameraCapture;
